import { Box, Button, Collapse, useMediaQuery, useTheme } from "@mui/material";
import DataTable from "components/DataTable";
import WindowDialog from "components/dialog/WindowDialog";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useEffect, useState } from "react";
import { filterList } from "../../DataFilter/filter";
import FormRow from "../FormRow";
import TextInput from "../input/TextInput";
import FForm from "..";
import SubmitButton from "../SubmitButton";
import FormContent from "../FormContent";

export default function EntitySearchDialog({ columns, data, ...props }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const [filters, setFilters] = useState();
    const [results, setResults] = useState([]);
    const [showFilterForm, setShowFilterForm] = useState(false);

    useEffect(() => {
        setResults(filterList(data, filters));
    }, [data, filters]);

    function handleFilter(values) {
        const newFilters = {};

        for (const field in values) {
            if (values[field]) {
                newFilters[field] = { value: values[field] };
            }
        }

        setFilters(newFilters);
    }

    function toggleFilterForm() {
        setShowFilterForm(!showFilterForm);
    }

    useEffect(() => {
        setShowFilterForm(!fullScreen);
    }, [fullScreen]);

    return (
        <WindowDialog
            contentProps={{ sx: { p: { xs: 0, sm: 3 } } }}
            {...props}
        >
            {(dialogProps) => (
                <Box
                    sx={{ display: "flex", flex: 1, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 0, sm: 2 } }}
                >
                    <Box className="filters" sx={{ maxWidth: { xs: "100%", sm: 200 }, p: { xs: 2, sm: 0 } }}>
                        <FForm onSubmit={handleFilter} contentProps={{ sx: { gap: showFilterForm ? 2 : 0 } }}>
                            <FormRow sx={{ flexDirection: "row-reverse", justifyContent: "space-between" }}>
                                <SubmitButton startIcon={<SearchIcon />} size="small">
                                    Buscar
                                </SubmitButton>

                                <Button
                                    onClick={toggleFilterForm}
                                    variant="contained"
                                    size="small"
                                    endIcon={showFilterForm ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                                    sx={{ display: fullScreen ? "flex" : "none" }}
                                >
                                    Filtros
                                </Button>
                            </FormRow>

                            <Collapse in={showFilterForm}>
                                <FormContent>
                                    {columns.map((column) => {
                                        if (column.filter) {
                                            return (
                                                <FormRow key={column.field}>
                                                    <TextInput name={column.field} label={column.headerName} />
                                                </FormRow>
                                            );
                                        } else {
                                            return null;
                                        }
                                    })}
                                </FormContent>
                            </Collapse>
                        </FForm>
                    </Box>
                    <Box sx={{ flex: 1, height: { xs: "100%", sm: "60vh" } }}>
                        <DataTable
                            columns={columns}
                            rows={results}
                            onRowClick={(row) => dialogProps.onClose(row.row)}
                            sx={{
                                "& .MuiDataGrid-row:hover": {
                                    cursor: "pointer",
                                },
                            }}
                        />
                    </Box>
                </Box>
            )}
        </WindowDialog>
    );
}
